import { FormikValues, useFormikContext } from 'formik';

import { User, Roles } from 'types';
import { Row, Col } from 'components/grid';
import { useListQuery } from 'store/api/users';
import { isEventManager } from 'utils/helpers';
import { SelectField } from 'components/fields';

import { EventTeamAssignSelectsProps } from './types';

const getFilteredOptions = (
  users: User[],
  filterFn: (user: User) => boolean,
  excludeValues: number[] = []
) =>
  users
    ?.filter(filterFn)
    ?.filter((user) => !excludeValues.includes(user.id))
    ?.map(({ id, name }) => ({
      value: id,
      label: name,
    })) ?? [];

export const EventTeamAssignSelects = ({
  colProps,
  ...props
}: EventTeamAssignSelectsProps) => {
  const { values } = useFormikContext<FormikValues>();
  const { data: users = { rows: [] } } = useListQuery({
    limit: 10000,
    onlyTeamMemberRoles: true,
  });

  const filteredManagerOptions = getFilteredOptions(
    users?.rows,
    isEventManager,
    values.teamMembers
  );

  const filteredUserOptions = getFilteredOptions(
    users?.rows,
    (user) => user.role?.name !== Roles.COMPANY_OWNER,
    [values.leaderId]
  );

  return (
    <Row>
      <Col {...colProps}>
        <SelectField
          onlyValue
          name="leaderId"
          label="Manager Assignment"
          placeholder="Manager Assignment"
          options={filteredManagerOptions}
          {...props}
        />
      </Col>

      <Col {...colProps}>
        <SelectField
          isMulti
          onlyValue
          name="teamMembers"
          label="Team Assignment"
          placeholder="Team Assignment"
          options={filteredUserOptions}
          {...props}
        />
      </Col>
    </Row>
  );
};
